/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Meeting_Delete_BodyInputs */



/**
* | output |
* | --- |
* | "The preparation and the report go with it. You added this conversation yourself, so nothing brings it back." |
*
* @param {Manual_Meeting_Delete_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manual_meeting_delete_body = /** @type {((inputs?: Manual_Meeting_Delete_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Meeting_Delete_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("De voorbereiding en het verslag gaan mee. Je hebt dit gesprek zelf toegevoegd, dus niets brengt het terug.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La préparation et le compte rendu partent avec elle. Vous avez ajouté cette conversation vous-même, donc rien ne la ramène.")
	return /** @type {LocalizedString} */ ("The preparation and the report go with it. You added this conversation yourself, so nothing brings it back.")
});